import clsx from 'clsx'

const DEFAULT_OPTIONS = {
  hideQuickAdd: false,
  hideSwatches: false,
  hidePromolines: false,
  hideBadges: false,
  hideWishlist: false
}

const SkeletonImage = () => {
  return (
    <div class="size-full bg-neutral-light animate-pulse">
    </div>
  )
}

const SkeletonDetails = () => {
  return (
    <div class="flex flex-col gap-y-0.125">
      <div className={'w-[45%] h-1.25 bg-brand-white'}></div>
      <div className={'w-[25%] h-1 bg-brand-white'}></div>
    </div>
  )
}

const SkeletonPromolines = () => {
  return (
    <div class="flex items-center gap-x-0.5">
      <div className={'w-[50px] h-1.5 bg-brand-white'}></div>
      <div className={'w-[50px] h-1.5 bg-brand-white'}></div>
    </div>
  )
}

export const SkeletonCard = ({ className, options = DEFAULT_OPTIONS }) => {
  return (
    <div class={clsx('grow grid grid-cols-1 w-full aspect-4/5 children:col-[1/1] children:row-[1/2]', className)}>
        <SkeletonImage />
        <div class="flex flex-col justify-between gap-y-1 size-full p-1.5 animate-pulse z-2">
          <SkeletonDetails />
          {!options.hidePromolines && <SkeletonPromolines />}
        </div>
    </div>
  )
}
